import { useMutation } from '@tanstack/react-query'
import toast from 'react-hot-toast'
import { useDispatch } from 'react-redux'
import { updateSession } from '../session'
import { SignUpData, SignUpResponse } from './types'

const URL = import.meta.env.VITE_EPC_API_URL ?? ''

export const useSignUpMutation = () => {
  const dispatch = useDispatch<any>()

  return useMutation({
    mutationFn: async (data: SignUpData) => {
      const res = await fetch(`${URL}/auth/signup`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify(data),
      })

      if (!res.ok) {
        const error = await res.json()
        throw new Error(error.message || 'Failed to sign up')
      }

      const responseData = (await res.json()) as SignUpResponse
      return responseData
    },
    onError: (error) => {
      console.error('Signup error:', error)
      toast.error(error.message)
    },
    onSuccess: (data) => {
      dispatch(
        updateSession({
          accessToken: data.access_token,
          refreshToken: data.refresh_token,
        })
      )
    },
  })
}
